import { defineComponent } from 'vue';
import { QItem, QItemSection, QIcon } from 'quasar';
import BaseComponent from '../BaseComponentMixin.jsx';
import utils from '../../../Shared/utils.jsx';

function normalizeIcon(icon) {
    if (typeof icon !== 'string')
        return icon || '';
    return icon.startsWith('mdi ') ? icon.substring(4) : icon;
}

const NavDrawerMenuItem = defineComponent({
    name: 'NavDrawerMenuItem',
    extends: BaseComponent,
    components: {
        QItem,
        QItemSection,
        QIcon,
    },
    emits: ['menu-action', 'finished-render'],
    props: {
        child: { type: Object, default: null },
        dense: { type: Boolean, default: true },
    },
    data() {
        return {
            titleexpn: null,
            iconexpn: null,
        };
    },
    computed: {
        data() {
            return this.child;
        },
        title() {
            const titleExpr = this.controlData?.Title;
            if (!titleExpr)
                return '—';
            try {
                if (!this.titleexpn)
                    this.titleexpn = utils.compile(this, titleExpr);
                const value = String(utils.evaluate(this.titleexpn, this) ?? '');
                // Vue2 navigation-drawer-popupmenuitem uses TranslationContainer (Translate + interpolate)
                return typeof this.Translate === 'function' ? this.Translate(value) : value;
            }
            catch (e) {
                return '—';
            }
        },
        icon() {
            const iconExpr = this.controlData?.Icon; //?.Icon;
            if (!iconExpr)
                return '';
            try {
                if (!this.iconexpn)
                    this.iconexpn = utils.compile(this, iconExpr);
                return normalizeIcon(String(utils.evaluate(this.iconexpn, this)));
            }
            catch (e) {
                return '';
            }
        },
        enabled() {
            if (!this.displayexpr && this.controlData && this.controlData.DisplayExpression)
                this.displayexpr = utils.compileExpression(this, this.controlData.DisplayExpression);

            if (this.displayexpr)
                return utils.evaluate(this.displayexpr, this);
            else
                return true;
        }
    },
    methods: {
        preRenderComplete() {
            this.finishRenderHandler(this);
        },
        onClick() {
            if (this.controlData?.Actions)
                utils.executeAndCompileAllActions(this.controlData.Actions, null, this);

            this.$emit('menu-action', {
                menuItem: this.child,
                handled: true,
            });
        },
    },
    render() {
        if (!this.enabled)
            return null;

        //if (!this.prerender_complete) {
        //    return (
        //        <QItem style="min-height: 32px; visibility: hidden; pointer-events: none;">
        //            <QItemSection />
        //        </QItem>
        //    );
        //}

        return (
            <QItem clickable onClick={this.onClick} xdisabled={!this.prerender_complete}>
                {this.icon ? (
                    <>
                        <QItemSection avatar>
                            <QIcon name={this.icon} size="sm" />
                        </QItemSection>
                        <QItemSection>{this.title}</QItemSection>
                    </>
                ) : (
                    <QItemSection>{this.title}</QItemSection>
                )}
            </QItem>
        );
    },
});

export default NavDrawerMenuItem;
